import { Injectable, EventEmitter } from '@angular/core';
import { IKart, IKartTuru, IIcerik, IVT, IYollar } from '@/src/service/fikoyt-ui/interfaces/IKart.interface';
import { IParametreSetiGrubu } from '@/src/service/fikoyt-ui/interfaces/IParametreSeti.interface';
import { ISablon } from '@/src/service/fikoyt-ui/src/lib/paylasim-sistemi/sablon-editoru/sablon.interface';
import { FikoYTId } from '@/src/service/fikoyt-ui/helpers/FikoYTId';
import { musteriAcilirKutu, firmaAcilirKutu, TR_RX_FN } from '../projeler/hmi-ortak-helpers';

const UYG = 'FikoYT.sistem.hmi.satis';

@Injectable({ providedIn: 'root' })
export class HmiSatisService {
  paylasimYapildi = new EventEmitter<any>(true);
  aktifIcerikNo = 0;

  kart: IKart = {
    _id: new FikoYTId().toString(),
    vt: 'FikoYT.sistem.hareketler' as IVT,
    yol: 'FikoYT.sistem.hareketler.kalem' as IYollar,
    turu: IKartTuru.KART,
    gizlilik: 'Herkese Açık',
    kisiler: [],
    veri: {
      solSimge: { aciklama: undefined, baslik: 'HMI', renkArka: '#ff9800', renkYazi: '#fff' },
      kurdela: { aciklama: undefined, baslik: 'Satış', renkArka: undefined, renkYazi: undefined },
      icerikler: [
        { _id: new FikoYTId().toString(), html: '', aciklama: '', sifre: null } as IIcerik,
      ],
    },
  };

  readonly parametreSetleri: IParametreSetiGrubu[] = [
    /* {
      id: 'hmi.siparis',
      baslik: 'Sipariş',
      simge: '🛒',
      aciklama: 'Sipariş kaydı oluştur',
      renk: 'linear-gradient(135deg, #e65100, #ff9800)',
      kaynak: 'kod',
      bilesen: 'siparis',
      parametreler: [
        { turu: 'Otomatik Kod', ismi: 'siparisNo', baslik: 'Sipariş No', ayarlar: { kodFormat: '{PREFIX}-{YIL}-{AY}-{SAYI:3}', kodPrefix: 'SP' } },
        { ...musteriAcilirKutu('musteri', 'Müşteri'), ayarlar: { ...musteriAcilirKutu('musteri', 'Müşteri').ayarlar, zorunlu: true } } as any,
        { turu: 'Yazı', ismi: 'urunAdi', baslik: 'Ürün Adı', ayarlar: { zorunlu: true } },
        { turu: 'Sayı', ismi: 'miktar', baslik: 'Miktar', ayarlar: { min: 1 } },
        { turu: 'Açılır Kutu', ismi: 'birim', baslik: 'Birim', ayarlar: {
          secenekler: [
            { label: 'Adet', value: 'Adet' }, { label: 'Kg', value: 'Kg' }, { label: 'Ton', value: 'Ton' },
            { label: 'Metre', value: 'Metre' }, { label: 'Takım', value: 'Takım' },
          ],
        } },
        { turu: 'Sayı', ismi: 'birimFiyat', baslik: 'Birim Fiyat', ayarlar: { min: 0, adim: 0.01 } },
        { turu: 'Açılır Kutu', ismi: 'paraBirimi', baslik: 'Para Birimi', ayarlar: {
          secenekler: [
            { label: '₺ TRY', value: 'TRY' }, { label: '$ USD', value: 'USD' }, { label: '€ EUR', value: 'EUR' },
          ],
        } },
        { turu: 'Tarih', ismi: 'teslimTarihi', baslik: 'Teslim Tarihi' },
        { turu: 'Açılır Kutu', ismi: 'durum', baslik: 'Durum', ayarlar: {
          itemSablon: { aktif: true, simgeGoster: false, renkGoster: true, aciklamaGoster: false, resimGoster: false },
          secenekler: [
            { label: 'Bekliyor', value: 'Bekliyor', renk: '#8c8c8c' },
            { label: 'Onaylandı', value: 'Onaylandı', renk: '#1890ff' },
            { label: 'Üretimde', value: 'Üretimde', renk: '#fa8c16' },
            { label: 'Hazır', value: 'Hazır', renk: '#52c41a' },
            { label: 'Sevk Edildi', value: 'Sevk Edildi', renk: '#13c2c2' },
            { label: 'İptal', value: 'İptal', renk: '#f5222d' },
          ],
        } },
        { turu: 'Yazı Alanı', ismi: 'notlar', baslik: 'Notlar' },
      ],
      sayfaKurallari: { yeniSayfaEngelle: true },
      sablon: {
        genislik: 520, yukseklik: 260, mod: 'serbest',
        arkaPlan: { tur: 'gradient', deger: 'linear-gradient(145deg, #3e1a00 0%, #e65100 50%, #ff9800 100%)' },
        bolgeler: [],
        elementler: [
          { id: 'sp0', tur: 'sekil', sekilTuru: 'dikdortgen', x: 0, y: 0, genislik: 520, yukseklik: 5, stil: { fill: 'rgba(255,255,255,0.15)' } },
          { id: 'sp1', tur: 'sabit-metin', icerik: '🛒', x: 5, y: 8, genislik: 50, yukseklik: 50, stil: { fontSize: 32, textAlign: 'center', verticalAlign: 'center' } },
          { id: 'sp1a', tur: 'parametre-render', parametreAnahtari: 'siparisNo', x: 16, y: 8, genislik: 160, yukseklik: 18, stil: { fontSize: 9, fontWeight: '700', color: 'rgba(255,224,178,0.7)', letterSpacing: 2, verticalAlign: 'center' } },
          { id: 'sp2', tur: 'parametre-metin', parametreAnahtari: 'musteri', x: 5, y: 20, genislik: 320, yukseklik: 30, stil: { fontSize: 20, fontWeight: '700', color: '#ffffff', verticalAlign: 'center' } },
          { id: 'sp3', tur: 'parametre-metin', parametreAnahtari: 'urunAdi', x: 5, y: 34, genislik: 400, yukseklik: 26, stil: { fontSize: 15, fontWeight: '500', color: '#ffe0b2', verticalAlign: 'center' } },
          { id: 'sp9a', tur: 'sekil', sekilTuru: 'dikdortgen', x: 72, y: 54, genislik: 120, yukseklik: 30, stil: { fill: 'rgba(255,255,255,0.08)', borderRadius: 15 } },
          { id: 'sp9', tur: 'parametre-render', parametreAnahtari: 'durum', x: 72, y: 54, genislik: 120, yukseklik: 30, stil: { fontSize: 12, fontWeight: '700', color: '#ffffff', textAlign: 'center', verticalAlign: 'center' } },
          { id: 'sp11', tur: 'sabit-metin', icerik: '◆ SİPARİŞ', x: 60, y: 92, genislik: 200, yukseklik: 16, stil: { fontSize: 8, fontWeight: '600', color: 'rgba(255,224,178,0.3)', verticalAlign: 'center', letterSpacing: 2, textAlign: 'right' } },
        ],
      } as ISablon,
      altKartSablonlari: [
        { id: 'hmi.siparis.kalem', baslik: 'Sipariş Kalemi', simge: '📦', bilesen: 'siparis-kalemi' },
        { id: 'hmi.siparis.durum', baslik: 'Durum Güncelleme', simge: '🔄', parametreler: [
          { turu: 'Açılır Kutu', ismi: 'durum', baslik: 'Durum', ayarlar: { zorunlu: true, secenekler: [
            { label: 'Bekliyor', value: 'Bekliyor', renk: '#8c8c8c' }, { label: 'Onaylandı', value: 'Onaylandı', renk: '#1890ff' },
            { label: 'Üretimde', value: 'Üretimde', renk: '#fa8c16' }, { label: 'Hazır', value: 'Hazır', renk: '#52c41a' },
            { label: 'Sevk Edildi', value: 'Sevk Edildi', renk: '#13c2c2' }, { label: 'İptal', value: 'İptal', renk: '#f5222d' },
          ], itemSablon: { aktif: true, renkGoster: true } } },
          { turu: 'Yazı Alanı', ismi: 'notlar', baslik: 'Açıklama' },
        ] },
      ],
    },
    {
      id: 'hmi.teklif',
      baslik: 'Teklif',
      simge: '📑',
      aciklama: 'Teklif hazırla',
      renk: 'linear-gradient(135deg, #1a237e, #5c6bc0)',
      kaynak: 'kod',
      bilesen: 'teklif',
      parametreler: [
        { turu: 'Otomatik Kod', ismi: 'teklifNo', baslik: 'Teklif No', ayarlar: { kodFormat: '{PREFIX}-{YIL}-{AY}-{SAYI:3}', kodPrefix: 'TK' } },
        { ...firmaAcilirKutu('firma', 'Firma / Müşteri'), ayarlar: { ...firmaAcilirKutu('firma', 'Firma / Müşteri').ayarlar, zorunlu: true } } as any,
        { turu: 'Yazı', ismi: 'yetkili', baslik: 'Yetkili Kişi' },
        { turu: 'Yazı', ismi: 'urunAdi', baslik: 'Ürün / Hizmet', ayarlar: { zorunlu: true } },
        { turu: 'Sayı', ismi: 'miktar', baslik: 'Miktar', ayarlar: { min: 1 } },
        { turu: 'Sayı', ismi: 'birimFiyat', baslik: 'Birim Fiyat', ayarlar: { min: 0, adim: 0.01 } },
        { turu: 'Açılır Kutu', ismi: 'paraBirimi', baslik: 'Para Birimi', ayarlar: {
          secenekler: [
            { label: '₺ TRY', value: 'TRY' }, { label: '$ USD', value: 'USD' }, { label: '€ EUR', value: 'EUR' },
          ],
        } },
        { turu: 'Tarih', ismi: 'gecerlilikTarihi', baslik: 'Geçerlilik Tarihi' },
        { turu: 'Açılır Kutu', ismi: 'durum', baslik: 'Durum', ayarlar: {
          itemSablon: { aktif: true, simgeGoster: false, renkGoster: true, aciklamaGoster: false, resimGoster: false },
          secenekler: [
            { label: 'Taslak', value: 'Taslak', renk: '#8c8c8c' },
            { label: 'Gönderildi', value: 'Gönderildi', renk: '#1890ff' },
            { label: 'Kabul Edildi', value: 'Kabul Edildi', renk: '#52c41a' },
            { label: 'Reddedildi', value: 'Reddedildi', renk: '#f5222d' },
          ],
        } },
        { turu: 'Yazı Alanı', ismi: 'aciklama', baslik: 'Açıklama / Notlar' },
      ],
      sayfaKurallari: { yeniSayfaEngelle: true },
      sablon: {
        genislik: 520, yukseklik: 280, mod: 'serbest',
        arkaPlan: { tur: 'gradient', deger: 'linear-gradient(145deg, #0a0e2a 0%, #1a237e 50%, #5c6bc0 100%)' },
        bolgeler: [],
        elementler: [
          { id: 'tk0', tur: 'sekil', sekilTuru: 'dikdortgen', x: 0, y: 0, genislik: 520, yukseklik: 5, stil: { fill: 'rgba(255,255,255,0.12)' } },
          { id: 'tk1', tur: 'sabit-metin', icerik: '📑', x: 5, y: 6, genislik: 50, yukseklik: 50, stil: { fontSize: 32, textAlign: 'center', verticalAlign: 'center' } },
          { id: 'tk1a', tur: 'parametre-render', parametreAnahtari: 'teklifNo', x: 16, y: 8, genislik: 160, yukseklik: 18, stil: { fontSize: 9, fontWeight: '700', color: 'rgba(159,168,218,0.7)', letterSpacing: 2, verticalAlign: 'center' } },
          { id: 'tk2', tur: 'parametre-metin', parametreAnahtari: 'firma', x: 5, y: 20, genislik: 350, yukseklik: 32, stil: { fontSize: 20, fontWeight: '700', color: '#ffffff', verticalAlign: 'center' } },
          { id: 'tk10', tur: 'sabit-metin', icerik: '◆ TEKLİF', x: 60, y: 92, genislik: 200, yukseklik: 16, stil: { fontSize: 8, fontWeight: '600', color: 'rgba(159,168,218,0.3)', verticalAlign: 'center', letterSpacing: 2, textAlign: 'right' } },
        ],
      } as ISablon,
      altKartSablonlari: [
        { id: 'hmi.teklif.revizyon', baslik: 'Revizyon', simge: '🔄', bilesen: 'revizyon' },
        { id: 'hmi.teklif.durum', baslik: 'Durum Güncelleme', simge: '🔄', parametreler: [
          { turu: 'Açılır Kutu', ismi: 'durum', baslik: 'Durum', ayarlar: { zorunlu: true, secenekler: [
            { label: 'Taslak', value: 'Taslak', renk: '#8c8c8c' }, { label: 'Gönderildi', value: 'Gönderildi', renk: '#1890ff' },
            { label: 'Kabul Edildi', value: 'Kabul Edildi', renk: '#52c41a' }, { label: 'Reddedildi', value: 'Reddedildi', renk: '#f5222d' },
          ], itemSablon: { aktif: true, renkGoster: true } } },
          { turu: 'Yazı Alanı', ismi: 'notlar', baslik: 'Açıklama' },
        ] },
      ],
    },
    {
      id: 'hmi.musteri',
      baslik: 'Müşteri',
      simge: '🏪',
      aciklama: 'Müşteri kaydı oluştur',
      renk: 'linear-gradient(135deg, #004d40, #00bfa5)',
      kaynak: 'kod',
      bilesen: 'musteri',
      parametreler: [
        { turu: 'Yazı', ismi: 'firmaAdi', baslik: 'Firma Adı', ayarlar: { zorunlu: true } },
        { turu: 'Yazı', ismi: 'yetkili', baslik: 'Yetkili Kişi' },
        { turu: 'Yazı', ismi: 'telefon', baslik: 'Telefon', ayarlar: { solSimge: '📱' } },
        { turu: 'Yazı', ismi: 'eposta', baslik: 'E-posta', ayarlar: { solSimge: '📧' } },
        { turu: 'Yazı', ismi: 'adres', baslik: 'Adres' },
        { turu: 'Yazı', ismi: 'vergiNo', baslik: 'Vergi No' },
        { turu: 'Açılır Kutu', ismi: 'sektor', baslik: 'Sektör', ayarlar: {
          secenekler: [
            { label: 'Otomotiv', value: 'Otomotiv' }, { label: 'Makine', value: 'Makine' },
            { label: 'İnşaat', value: 'İnşaat' }, { label: 'Enerji', value: 'Enerji' },
            { label: 'Savunma', value: 'Savunma' }, { label: 'Gıda', value: 'Gıda' },
            { label: 'Diğer', value: 'Diğer' },
          ],
        } },
        { turu: 'Yazı Alanı', ismi: 'notlar', baslik: 'Notlar' },
      ],
      sablon: {
        genislik: 520, yukseklik: 200, mod: 'serbest',
        arkaPlan: { tur: 'gradient', deger: 'linear-gradient(145deg, #002420 0%, #004d40 50%, #00bfa5 100%)' },
        bolgeler: [],
        elementler: [
          { id: 'mu0', tur: 'sekil', sekilTuru: 'dikdortgen', x: 0, y: 0, genislik: 520, yukseklik: 5, stil: { fill: 'rgba(255,255,255,0.12)' } },
          { id: 'mu1', tur: 'sabit-metin', icerik: '🏪', x: 5, y: 6, genislik: 46, yukseklik: 46, stil: { fontSize: 28, textAlign: 'center', verticalAlign: 'center' } },
          { id: 'mu2', tur: 'parametre-metin', parametreAnahtari: 'firmaAdi', x: 5, y: 22, genislik: 400, yukseklik: 34, stil: { fontSize: 22, fontWeight: '700', color: '#ffffff', verticalAlign: 'center' } },
          { id: 'mu9', tur: 'sabit-metin', icerik: '◆ MÜŞTERİ KAYDI', x: 3, y: 88, genislik: 200, yukseklik: 16, stil: { fontSize: 8, fontWeight: '600', color: 'rgba(167,255,235,0.3)', verticalAlign: 'center', letterSpacing: 2 } },
        ],
      } as ISablon,
      altKartSablonlari: [
        { id: 'hmi.musteri.gorusme', baslik: 'Görüşme Notu', simge: '💬', bilesen: 'gorusme-notu' },
      ],
    }, */
  ];

  icerikEkle(ek: any = null) {
    if (!ek) {
      ek = { turu: 'UYGULAMAICERIK', _id: '', parametreler: [] };
    }
    this.kart?.veri?.icerikler?.push({
      _id: new FikoYTId().toString(), aciklama: '', html: '', ek, sifre: null,
    }) ?? 0;
  }

  sifirla() {
    this.kart = {
      _id: new FikoYTId().toString(),
      vt: 'FikoYT.sistem.hareketler' as IVT,
      yol: 'FikoYT.sistem.hareketler.kalem' as IYollar,
      turu: IKartTuru.KART,
      gizlilik: 'Herkese Açık',
      kisiler: [],
      veri: {
        solSimge: { aciklama: undefined, baslik: 'HMI', renkArka: '#ff9800', renkYazi: '#fff' },
        kurdela: { aciklama: undefined, baslik: 'Satış', renkArka: undefined, renkYazi: undefined },
        icerikler: [],
      },
    };
    this.icerikEkle();
  }

  aktifEtSonSayfa() {
    this.aktifIcerikNo = (this.kart?.veri?.icerikler?.length ?? 1) - 1;
  }
}
